// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__DZXKd","selected":"Chip_selected__2JOFn"};